import { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { debounce } from 'lodash';

import { InputSearch } from '@/components/ui/input-search';

import { useApplications } from '../model';

const ApplicationsSearchInput = () => {
  const { search, setSearch } = useApplications();
  const [localValue, setLocalValue] = useState(search);
  const [prevSearch, setPrevSearch] = useState(search);

  const setSearchRef = useRef(setSearch);
  useLayoutEffect(() => {
    setSearchRef.current = setSearch;
  });
  const debouncedSetSearch = useRef(debounce((value: string) => setSearchRef.current(value), 300)).current;

  // `search` lives in the URL, so Back/Forward or a nav link can change it without going through this input.
  if (search !== prevSearch) {
    setPrevSearch(search);
    setLocalValue(search);
  }

  useEffect(() => () => debouncedSetSearch.cancel(), [debouncedSetSearch]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setLocalValue(event.target.value);
    debouncedSetSearch(event.target.value);
  };

  const handleClear = () => {
    debouncedSetSearch.cancel();
    setLocalValue('');
    setSearch('');
  };

  return (
    <InputSearch
      placeholder="Search applications"
      className="flex-1 sm:flex-initial"
      value={localValue}
      onChange={handleChange}
      onClear={handleClear}
      isLoading={false}
    />
  );
};

export default ApplicationsSearchInput;
